import { Component, input, InputSignal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Tag } from '@app/shared/types/models/tag/tag.model';

@Component({
  selector: 'proffeo-tag',
  templateUrl: './tag.component.html',
  imports: [MatTooltipModule],
  host: {
    '[matTooltip]': 'tag().description',
    class: 'w-fit inline-flex truncate max-w-40 border-1 rounded-lg px-2 text-sm md:text-base cursor-default',
    '[style.border-color]': '`${tag().hexColor}60`',
    '[style.background-color]': '`${tag().hexColor}20`'
  }
})
export class TagComponent {
  public readonly tag: InputSignal<Tag | string> = input.required<Tag | string>();
}
